import { getAssignPayLink } from 'api/money/money';
import { withContainer } from 'components/Container';
import { useNumberId } from 'hooks/useId';
import { useEffect, useState } from 'react';
import { TextM } from 'ui/Styled/Styled';
import styled from 'styled-components';
import { FetchError } from 'typings/fetch';
import { getMessage } from 'messages';
import { useUserType } from 'context/Auth';
import { UserType } from 'api/api';
import { PRODUCTION_URL } from 'helpers/constants';

const CenteredText = styled(TextM)`
    text-align: center;
`;

// TODO: Если эта ссылка была открыта с другой страницы, то после оплата нужно закрыть окно и вернуться на предыдущую страницу

const PayAssign = () => {
    const id = useNumberId();
    const [error, setError] = useState<React.ReactNode | null>(null);
    const userType = useUserType();

    useEffect(() => {
        if (id) {
            getAssignPayLink(
                id,
                userType !== UserType.Operator ? PRODUCTION_URL : undefined
            )
                .then((res) => {
                    if (res.confirmUrl) {
                        window.location.href = res.confirmUrl;
                    } else {
                        setError('Не удалось получить ссылку на оплату');
                    }
                })
                .catch((err: FetchError) => {
                    setError(err.msg ?? (err.code && getMessage(err.code)));
                });
        }
    }, [id, userType]);

    return (
        <CenteredText>
            {error ? error : 'Переадресуем на оплату...'}
        </CenteredText>
    );
};

export default withContainer(PayAssign, {
    heading: 'Оплата назначения'
});
